// Tracks the set of top-level (base) category slugs registered at bootstrap
// (e.g. "motors", "test"). This lets us tell a real base-category segment apart
// from a profile id without hardcoding any single vertical: the router only
// falls through to the account ":id" route when the first URL segment matches
// no known category, so anything not in this set is treated as a profile.

const baseCategorySlugs = new Set<string>();

export function registerBaseCategorySlugs(slugs: Array<string | undefined | null>): void {
  for (const slug of slugs) {
    if (slug && slug !== '**' && !slug.startsWith(':')) {
      baseCategorySlugs.add(slug.replace(/^all-/, ''));
    }
  }
}

export function isKnownBaseCategory(slug: string | undefined | null): boolean {
  if (!slug) {
    return false;
  }
  return baseCategorySlugs.has(slug.replace(/^all-/, ''));
}
